import { Button, ButtonIcon, Title, tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

export const SearchTitle = styled(Title)`
  margin: ${tokens.spacing.verticalLarge} 0 ${tokens.spacing.horizontalMedium}
    ${tokens.spacing.horizontalMedium};
`

export const ListItemWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  border-bottom: solid 1px ${tokens.colors.dark1};
  justify-content: space-between;

  &:last-of-type {
    border-bottom: none;
  }

  li {
    border: none;
  }
`

export const ButtonIconStyled = styled(ButtonIcon)`
  margin-right: ${tokens.spacing.horizontalSmall};
`

export const ButtonWrapper = styled.div`
  margin-top: ${tokens.spacing.verticalXsmall};
  display: flex;
  justify-content: center;
`

export const EmptyStateWrapper = styled.div`
  margin: 130px auto 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  max-width: 500px;
`

export const EmptyStateWrapperCompact = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  height: 400px;
  padding: 0 ${tokens.spacing.horizontalMedium};
`

export const EmptyStateImage = styled.img`
  width: 200px;
  height: auto;
  margin-bottom: ${tokens.spacing.verticalMedium};
`

export const HistoryHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: ${tokens.spacing.horizontalSmall};

  ${SearchTitle} {
    margin: ${tokens.spacing.verticalMedium} 0 ${tokens.spacing.verticalSmall}
      ${tokens.spacing.horizontalMedium};
  }
`

export const ClearButton = styled(Button)`
  flex-shrink: 0;
`

export const TitleEmptyState = styled(Title)`
  max-width: 230px;
  text-align: center;
  color: ${tokens.colors.dark6};
`

export const ParagraphEmptyState = styled.p`
  color: ${tokens.colors.dark5};
  font-size: ${tokens.fontSize.medium};
  max-width: 290px;
  text-align: center;
`
